export default __webpack_public_path__ + "static/media/404.89a0a1db.jpg";